module.exports = __webpack_public_path__ + "static/media/404.9638c3e3.jpg";